export default "__VITE_ASSET__2Wyjwdhs__"